module.exports = __webpack_public_path__ + "img/newyear_award_title.bf27229b.png";